"use strict";

exports.__esModule = true;
exports.fetchContentMigrationStatusForBusinessManager = exports.contentMigrationFetchStatus = exports.getMigrationStatusPath = exports.MIGRATION_STATUS_PATH = exports.contentMigrationSetStatus = exports.contentMigrationFetchStatusFailure = exports.contentMigrationFetchStatusSuccess = exports.contentMigrationFetchStatusRequest = exports.CONTENT_MIGRATION_SET_STATUS = exports.CONTENT_MIGRATION_FETCH_STATUS_FAILURE = exports.CONTENT_MIGRATION_FETCH_STATUS_SUCCESS = exports.CONTENT_MIGRATION_FETCH_STATUS_REQUEST = void 0;

var _searchParamsSelectors = require("../selectors/search-params-selectors");

var _currentUserSelectors = require("../selectors/current-user-selectors");

var _createAction = _interopRequireDefault(require("../services/create-action"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CONTENT_MIGRATION_FETCH_STATUS_REQUEST = 'contentMigration/FETCH_STATUS_REQUEST';
exports.CONTENT_MIGRATION_FETCH_STATUS_REQUEST = CONTENT_MIGRATION_FETCH_STATUS_REQUEST;
var CONTENT_MIGRATION_FETCH_STATUS_SUCCESS = 'contentMigration/FETCH_STATUS_SUCCESS';
exports.CONTENT_MIGRATION_FETCH_STATUS_SUCCESS = CONTENT_MIGRATION_FETCH_STATUS_SUCCESS;
var CONTENT_MIGRATION_FETCH_STATUS_FAILURE = 'contentMigration/FETCH_STATUS_FAILURE';
exports.CONTENT_MIGRATION_FETCH_STATUS_FAILURE = CONTENT_MIGRATION_FETCH_STATUS_FAILURE;
var CONTENT_MIGRATION_SET_STATUS = 'contentMigration/SET_STATUS';
exports.CONTENT_MIGRATION_SET_STATUS = CONTENT_MIGRATION_SET_STATUS;
var contentMigrationFetchStatusRequest = (0, _createAction["default"])(CONTENT_MIGRATION_FETCH_STATUS_REQUEST);
exports.contentMigrationFetchStatusRequest = contentMigrationFetchStatusRequest;
var contentMigrationFetchStatusSuccess = (0, _createAction["default"])(CONTENT_MIGRATION_FETCH_STATUS_SUCCESS);
exports.contentMigrationFetchStatusSuccess = contentMigrationFetchStatusSuccess;
var contentMigrationFetchStatusFailure = (0, _createAction["default"])(CONTENT_MIGRATION_FETCH_STATUS_FAILURE);
exports.contentMigrationFetchStatusFailure = contentMigrationFetchStatusFailure;
var contentMigrationSetStatus = (0, _createAction["default"])(CONTENT_MIGRATION_SET_STATUS);
exports.contentMigrationSetStatus = contentMigrationSetStatus;
var MIGRATION_STATUS_PATH = '/_api/content-migration/details';
exports.MIGRATION_STATUS_PATH = MIGRATION_STATUS_PATH;

var getMigrationStatusPath = function getMigrationStatusPath(viewMode) {
  return MIGRATION_STATUS_PATH + "?viewMode=" + viewMode;
};

exports.getMigrationStatusPath = getMigrationStatusPath;

var contentMigrationFetchStatus = function contentMigrationFetchStatus(viewMode) {
  return function (dispatch, getState, _ref) {
    var request = _ref.request;
    dispatch(contentMigrationFetchStatusRequest());
    var promise = request(getMigrationStatusPath(viewMode || (0, _searchParamsSelectors.getViewMode)(getState())));
    return promise.then(function (details) {
      return dispatch(contentMigrationFetchStatusSuccess(details));
    }, function () {
      return dispatch(contentMigrationFetchStatusFailure());
    }).then(function () {
      return promise;
    });
  };
};

exports.contentMigrationFetchStatus = contentMigrationFetchStatus;

var fetchContentMigrationStatusForBusinessManager = function fetchContentMigrationStatusForBusinessManager() {
  return function (dispatch, getState) {
    var state = getState();
    return (0, _currentUserSelectors.isOwner)(state) ? dispatch(contentMigrationFetchStatus('editor')) : Promise.resolve();
  };
};

exports.fetchContentMigrationStatusForBusinessManager = fetchContentMigrationStatusForBusinessManager;